function buildAddressComponents(value) {
  if (value?.isManual) {
    return value;
  }
  return {
    streetLine: buildStreetLine(value),
    unit: findAddressComponent(value, "subpremise"),
    suburb: findAddressComponent(value, "locality"),
    state: buildState(value),
    postcode: findAddressComponent(value, "postal_code"),
  };
}

function buildStreetLine(value) {
  const streetNumber = findAddressComponent(value, "street_number");
  const route = findAddressComponent(value, "route");
  return [streetNumber, route].join(" ").trim();
}

function buildState(value) {
  const rawState = findAddressComponent(value, "administrative_area_level_1");
  return getStateOptions().find((s) => s.label === rawState)?.id;
}

function findAddressComponent(value = {}, type) {
  const { addressComponents = [] } = value;
  const component = addressComponents.find((c) => (c.types || []).includes(type));
  return component?.long_name;
}

function getStateOptions() {
  return [
    {
      label: "Victoria",
      id: "VIC",
    },
    {
      label: "South Australia",
      id: "SA",
    },
    {
      label: "New South Wales",
      id: "NSW",
    },
    {
      label: "Queensland",
      id: "QLD",
    },
    {
      label: "Tasmania",
      id: "TAS",
    },
    {
      label: "Western Australia",
      id: "WA",
    },
    {
      label: "Australian Capital Territory",
      id: "ACT",
    },
    {
      label: "Northern Territory",
      id: "NT",
    },
  ];
}

export { buildAddressComponents, getStateOptions };
